<template>
  <card-modal>
    <template v-slot:header>
      <h1>Add bridge</h1>
    </template>

    <template slot="content">
      <ion-item>
        <ion-label position="floating">
          Region
        </ion-label>
        <ion-select-vue 
          v-model="bridge.region"
          interface="popover"
        >
          <ion-select-option 
            v-for="type in region" 
            :key="type.key"
            :value="type.value"
          >
            {{ type.key }}
          </ion-select-option>
        </ion-select-vue>
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          Cloud region
        </ion-label>
        <ion-select-vue 
          v-model="bridge.cloud_region"
          interface="popover"
        >
          <ion-select-option 
            v-for="type in cloudRegion" 
            :key="type.key"
            :value="type.value"
          >
            {{ type.key }}
          </ion-select-option>
        </ion-select-vue>
      </ion-item>

      <ion-item class="item-interactive">
        <ion-label>Virtual</ion-label>
        <ion-checkbox-vue 
          v-model="bridge.virtual"
        />
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          Release
        </ion-label>
        <ion-select-vue
          v-model="bridge.release_track"
          interface="popover"
        >
          <ion-select-option
            v-for="track in releaseTrack"
            :key="track.key"
            :value="track.value"
          >
            {{ track.key }}
          </ion-select-option>
        </ion-select-vue>
      </ion-item>
    </template>

    <template slot="footer">
      <ion-button
        :disabled="busy"
        expand="full"
        @click="save"
      >
        <ion-spinner v-if="busy" />
        <template v-else>
          Add
        </template>
      </ion-button>
    </template>
  </card-modal>
</template>

<script>
import CardModal from '../../common/CardModal'

import { IonSelectVue, IonCheckboxVue, modalController } from '@modus/ionic-vue'
import { region } from '../../bridge/region'

import cloudRegion from '../../bridge/cloudRegion'
import { releaseTrack } from '../../releases/releaseTrack';

import store from '../../state'

export default {
  components: {
    CardModal,
    IonSelectVue,
    IonCheckboxVue
  },
  data() {
    let availableRegions = [...cloudRegion].filter(r => !["UNKNOWN", "US_1", "STAGING"].includes(r.key))
    return {
      busy: false,
      bridge: {
        region: region.US.value,
        cloud_region: cloudRegion.US_2.value,
        is_virtual: false,
        release_track: 'production',
      },
      region,
      cloudRegion: availableRegions,
      releaseTrack
    }
  },
  methods: {
    save() {
      this.busy = true

      store.dispatch('createBridge', this.bridge)
        .then(() => modalController.dismiss())
        .finally(() => this.busy = false)
    }
  }
}
</script>